import { Injectable } from '@angular/core';
import { UserService } from '@shared/services/user.service';

const menuConfig = require("@configs/menu.json");

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private userService: UserService) {}

  getMenu() {
    return menuConfig.voices.map((voice) => {
      voice.disabled = voice.disabled ? !this.userService.isPermissionEnable(voice.disabled) : false;
      if (voice.childrens) {
        voice.childrens = voice.childrens.map((child) => {
          child.disabled = child.disabled ? !this.userService.isPermissionEnable(child.disabled) : false;
          return child;
        })
      }
      return voice;
    })
  }
}